import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
const arrow = (active) => (React.createElement("svg", { height: "24px", id: "arrow", viewBox: "0 0 24 24", width: "24px" },
    React.createElement("g", { transform: active ? 'translate(24 0) rotate(90)' : 'translate(0 24) rotate(-90)' },
        React.createElement("g", null,
            React.createElement("g", { transform: "translate(8 7)" },
                React.createElement("path", { d: "M0,6.586V0H6.586", fill: "none", stroke: "#5047FF", strokeMiterlimit: "10", strokeWidth: "1.5", transform: "translate(0.686 5.157) rotate(-45)" }))))));
const Accordion = ({ item, menuReset }) => {
    const { label, icon, subItems } = item;
    const [active, setActive] = useState(false);
    return (React.createElement("div", { className: "accordion" },
        React.createElement("div", { className: "accordion__title", "data-cy": label, onClick: () => {
                setActive((prevState) => !prevState);
            } },
            icon,
            React.createElement("span", null, label),
            React.createElement("span", { className: "drop-arrow" }, arrow(active))),
        active && subItems && (React.createElement("div", { className: "accordion__items" }, subItems.map((subItem) => (React.createElement(SidebarMenuItem, { item: subItem, key: subItem.name, menuReset: menuReset })))))));
};
export const SidebarMenuItem = ({ item, menuReset }) => {
    const { label, url, icon } = item;
    return url ? (url.startsWith('/', 0) ? (React.createElement(NavLink, { className: ({ isActive }) => isActive ? 'nav-link nav-link--active' : 'nav-link', "data-cy": label, onClick: () => {
            if (menuReset)
                menuReset();
        }, to: url },
        React.createElement("div", { className: "nav-link__items" },
            icon,
            React.createElement("span", null, label)))) : (React.createElement("a", { className: "nav-link", "data-cy": label, href: url, onClick: () => {
            if (menuReset)
                menuReset();
        }, rel: "noreferrer", target: "_blank" },
        React.createElement("div", { className: "nav-link__items" },
            icon,
            React.createElement("span", null, label))))) : (React.createElement(Accordion, { item: item, menuReset: menuReset }));
};
